import { render, staticRenderFns } from "./ExpertisePageIndex.vue?vue&type=template&id=872cf260&"
import script from "./ExpertisePageIndex.vue?vue&type=script&lang=ts&"
export * from "./ExpertisePageIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('872cf260')) {
      api.createRecord('872cf260', component.options)
    } else {
      api.reload('872cf260', component.options)
    }
    module.hot.accept("./ExpertisePageIndex.vue?vue&type=template&id=872cf260&", function () {
      api.rerender('872cf260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Expertises/ExpertisePageIndex.vue"
export default component.exports